export const L = {
  appTitle:      'TAVELO ADMIN',
  signOut:       'Sign out',

  loginTitle:    'Tavelo Admin',
  loginEmail:    'Email',
  loginPassword: 'Password',
  loginSubmit:   'Sign in',
  loginPending:  'Signing in…',

  unauthorized:  'Not authorised. If you should have access to this page, contact the platform owner.',
  mobileSplash:  'Tavelo Admin works best on a wider screen. Please open this page on a laptop or desktop.',

  statTotal:     'Total',
  statTrial:     'Trial',
  statGrace:     'Grace',
  statPaid:      'Paid',
  statExpired:   'Expired',
  statCancelled: 'Cancelled',
  statNewWeek:   'New this week',

  filterAll:       'All',
  filterTrial:     'Trial',
  filterGrace:     'Grace',
  filterPaid:      'Paid',
  filterExpired:   'Expired',
  filterCancelled: 'Cancelled',

  colHotel:    'Hotel',
  colOwner:    'Owner',
  colStatus:   'Status',
  colDays:     'Days',
  colLastSeen: 'Last seen',
  colDaysTip:  'trial → days left · grace → grace days left · expired → days since expiry',

  btnNew:           '+ New',
  btnPlus7:         '+ 7 days',
  btnPlus30:        '+ 30 days',
  btnCustomDate:    'Custom date…',
  btnMarkPaid:      'Mark paid',
  btnMarkCancelled: 'Mark cancelled',

  notesLabel:  'Notes',
  notesSaved:  '✓ Saved',
  notesExpired: 'Session expired — sign in to save',
  notesSaveError: 'Save failed — please try again',

  extendError:       'Couldn’t extend trial — please try again',
  customDateError:   'Couldn’t apply date — please try again',
  markPaidError:     'Couldn’t mark paid — please try again',
  markCancelledError:'Couldn’t mark cancelled — please try again',
  sessionExpired:    'Session expired — sign in again',

  newCustomerTitle:    'New customer',
  newCustomerHotel:    'Hotel name',
  newCustomerOwner:    'Owner full name',
  newCustomerEmail:    'Owner email',
  newCustomerCountry:  'Country',
  newCustomerTrial:    'Trial length',
  newCustomerSubmit:   'Create customer',
  newCustomerCancel:   'Cancel',

  countryGR: 'Greece (GR)',
  countryBG: 'Bulgaria (BG)',

  trial14:  '14 days',
  trial30:  '30 days',
  trial60:  '60 days',
  trial90:  '90 days',
  trialCustom: 'Custom date…',
};
